import React from 'react';
import styled from 'styled-components';
import ColorSelector from './ColorSelector';
import { CardColor } from '../../types';

interface CardFooterProps {
  currentColor: string;
  onColorSelect: (color: CardColor) => void;
}

// カードのフッター
const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;

const CardFooter: React.FC<CardFooterProps> = ({ currentColor, onColorSelect }) => {
  return (
    <FooterContainer>
      <ColorSelector 
        currentColor={currentColor} 
        onColorSelect={onColorSelect} 
      />
    </FooterContainer>
  );
};

export default CardFooter; 